var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tokens"},[_c('FdToken',{on:{"click":_vm.click}},[_vm._v("Click Me")]),_c('FdToken',[_vm._v("Lorem")]),_c('FdToken',[_vm._v("Dolor")]),_c('FdToken',[_vm._v("Filter")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }